import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { H5, Paragraph } from 'components/core/Typography';
import { Section } from 'components/core/Page';
import { truckTypes } from 'config/units';
import { FilterButton } from 'components/search/FilterButton';
import { TrackingClient } from '@sparefoot/tracking-client';
import { encode } from 'querystring';

// isPenske, allTruckRental, truckRental, freeTruckRental
const truckParamKeys = truckTypes.map((obj) => obj.value);

export const enhance = (WrappedComponent) => {
	const WithTruckFilterProps = (props) => {
		const { onFilter, queryParams } = props;

		const handleTruckFilter = useCallback(
			(searchParam, value) => {
				const newTruckParams = {
					allTruckRental: false,
					truckRental: false,
					freeTruckRental: false,
					isPenske: false,
				};
				newTruckParams[searchParam] = value;

				TrackingClient.trackSearchFiltered({
					search_filters: encode(newTruckParams),
					search_label: `${searchParam}-${value}`,
					search_term: searchParam,
				});

				onFilter(newTruckParams);
			},
			[onFilter],
		);

		const derivedProps = useMemo(() => {
			if (queryParams) {
				// If no truck queryParam keys exist or they do but != true
				if (
					truckParamKeys.filter(
						(truckParam) =>
							queryParams[truckParam] === 'true' ||
							queryParams[truckParam] === true,
					).length === 0
				) {
					return {
						queryParams: {
							allTruckRental: true, // Default filter when none are set
						},
					};
				}
			}
			return {};
		}, [queryParams]);

		return (
			<WrappedComponent
				{...props}
				{...derivedProps}
				handleTruckFilter={handleTruckFilter}
			/>
		);
	};
	return WithTruckFilterProps;
};

export function TruckFilterContent({ handleTruckFilter, queryParams }) {
	return (
		<div className="filter-content">
			<H5 size="small">Narrow Your Results</H5>
			<Section>
				<Paragraph eyebrow>Type of Moving Trucks</Paragraph>
				<ul className="filter-group">
					{truckTypes.map((type) => (
						<li
							key={type.value}
							className="filter-item truck-filter-item"
						>
							<FilterButton
								label={type.label}
								value="true"
								icon={type.icon}
								type={type.value}
								selected={!!queryParams[type.value]}
								onClick={handleTruckFilter}
							/>
						</li>
					))}
				</ul>
			</Section>
		</div>
	);
}

TruckFilterContent.propTypes = {
	handleTruckFilter: PropTypes.func,
	queryParams: PropTypes.object,
};

export default enhance(TruckFilterContent);
